module.exports = __webpack_public_path__ + "static/media/logo_UnderwaterMuse.290ce86a.svg";